import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSupabaseAuth } from '@/components/auth';
import { websiteUrls } from '@/lib/site-urls';

export interface UserInfo {
  id: string
  firstName: string;
  lastName: string;
  email: string;
}

function extractUserInfo(user: { user_metadata?: Record<string, unknown>; email?: string; id?: any } | null): UserInfo | null {
  if (!user) return null;
  const meta = user.user_metadata ?? {};
  const fullName = (meta.full_name as string) ?? (meta.name as string) ?? '';
  const parts = fullName.split(' ');
  return {
    id: user.id ?? "",
    firstName: parts[0] ?? '',
    lastName: parts.slice(1).join(' ') ?? '',
    email: user.email ?? '',
  };
}

export async function signInRedirect() {
    window.location.href = websiteUrls.login
}
export function useAuth() {
  const { session, user, token, loading, signIn, signOut } = useSupabaseAuth();
  const isAnonymous = !!user?.is_anonymous;
  const isAuthenticated = !!session && !isAnonymous;
  const userInfo = extractUserInfo(user);
  const authProvider: string | null = isAnonymous
    ? 'anonymous'
    : (user?.app_metadata?.provider as string) ?? null;

  const navigate = useNavigate();
  const logout = useCallback(async () => {
    await signOut();
    navigate('/');
  }, [signOut, navigate]);

  return {
    isAuthenticated,
    isAnonymous,
    authProvider,
    token,
    user: userInfo,
    loading,
    error: null as string | null,
    signIn,
    logout,
  };
}
